import React, { useEffect } from "react";
import Carousel from 'react-multi-carousel';
import Carousel2 from 'react-multi-carousel';
import Carousel3 from 'react-multi-carousel';
import Carousel4 from 'react-multi-carousel';
import Carousel5 from 'react-multi-carousel';
import Carousel6 from 'react-multi-carousel';
import { useState } from "react";
import 'react-multi-carousel/lib/styles.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 3,
        slidesToSlide: 3 // optional, default to 1.
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2,
        slidesToSlide: 2 // optional, default to 1.
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
        slidesToSlide: 1 // optional, default to 1.
    }
};

const responsive2 = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 5,
        slidesToSlide: 5,
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 3,
        slidesToSlide: 3,
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
        slidesToSlide: 1,
    },
};



// const responsive2 = {
//     desktop: {
//         breakpoint: { max: 3000, min: 1024 },
//         items: 4,
//         slidesToSlide: 4 // optional, default to 1.
//     },
//     tablet: {
//         breakpoint: { max: 1024, min: 464 },
//         items: 2,
//         slidesToSlide: 2 // optional, default to 1.
//     },
//     mobile: {
//         breakpoint: { max: 464, min: 0 },
//         items: 1,
//         slidesToSlide: 1 // optional, default to 1.
//     }
// };
function Home() {

    useEffect(() => {
        const carouselElement = document.getElementById('carouselExampleCaptions');
        if (carouselElement) {
            // Initialize the Bootstrap carousel
            const bsCarousel = new window.bootstrap.Carousel(carouselElement, {
                interval: 3000,
                ride: 'carousel',
                pause: false
            });

            // Force start the cycling immediately
            bsCarousel.cycle();

            // Cleanup on unmount
            return () => bsCarousel.dispose();
        }
    }, []);

    const services = [
  {
    number: "01",
    title: "Infrastructure Solutions",
    subtitle: "Cloud • Data Center • Network",
    image: "assets/img/infrastructure1.jpg",
    description:
      "Empower your business with scalable, secure and resilient infrastructure solutions that support modern digital transformation initiatives.",
    points: [
      "Cloud Infrastructure",
      "Private 5G",
      "Data Centers",
      "Managed Services"
    ],
    link: "/infrastructure"
  },

  {
    number: "02",
    title: "Business Analytics",
    subtitle: "AI • Dashboards • Insights",
    image: "assets/img/businessanalytics.jpg",
    description:
      "Transform enterprise data into meaningful insights using intelligent analytics, reporting and visualization solutions.",
    points: [
      "Power BI",
      "Data Visualization",
      "Predictive Analytics",
      "Business Intelligence"
    ],
    link: "/business"
  },

  {
    number: "03",
    title: "ERP Solutions",
    subtitle: "SAP • Oracle • Integration",
    image: "assets/img/saperp.jpeg",
    description:
      "Optimize business operations with SAP and Oracle ERP solutions that improve productivity and accelerate business growth.",
    points: [
      "SAP",
      "Oracle",
      "Migration",
      "Support"
    ],
    link: "/erp"
  },

  {
    number: "04",
    title: "Cybersecurity",
    subtitle: "SOC • Zero Trust • SIEM",
    image: "assets/img/cybersecurity.jpg",
    description:
      "Protect enterprise assets with advanced cybersecurity solutions designed for modern digital businesses.",
    points: [
      "Security Operations",
      "Compliance",
      "Risk Management",
      "Threat Detection"
    ],
    
    link: "/cyber"
  },

  {
    number: "05",
    title: "Microservices",
    subtitle: "Containers • APIs • DevOps",
    image: "assets/img/microserv.jpeg",
    description:
      "Develop scalable cloud-native applications using modern microservices architecture and DevOps practices.",
    points: [
      "Containers",
      "Docker",
      "Kubernetes",
      "API Management"
    ],
    link: "/micro"
  },

  {
    number: "06",
    title: "IT Staffing",
    subtitle: "Talent • Recruitment • Delivery",
    image: "assets/img/itstaff.jpg",
    description:
      "Connect with highly skilled technology professionals who accelerate your digital transformation journey.",
    points: [
      "Permanent Hiring",
      "Contract Staffing",
      "Executive Search",
      "Dedicated Teams"
    ],
    link: "/It"
  }
];

const [activeService, setActiveService] = useState(0);


const solutions = [
  {
    title: "Managed Services",
    image: "assets/img/managed-services.jpg",
    description:
      "Delivering proactive monitoring, infrastructure management and enterprise IT support to keep your business running without interruption.",
    tags: [
      "24×7 Monitoring",
      "Cloud Support",
      "Infrastructure",
      "IT Operations"
    ],
    link: "/managed-services"
  },

  {
    title: "Data Center Solutions",
    image: "assets/img/datacenter-banner.jpg",
    description:
      "Designing resilient, scalable and future-ready data center environments that maximize performance and business continuity.",
    tags: [
      "Infrastructure",
      "Capacity Planning",
      "Power & Cooling",
      "Modernization"
    ],
    link: "/datacenters"
  },

  {
    title: "Private 5G Solutions",
    image: "assets/img/private5g.jpg",
    description:
      "Secure enterprise-grade private 5G networks that enable low latency connectivity across manufacturing, logistics and smart facilities.",
    tags: [
      "Low Latency",
      "Industrial IoT",
      "Enterprise Connectivity",
      "Wireless"
    ],
    link: "/private5g"
  },

  {
    title: "Industrial AR Solutions",
    image: "assets/img/industrial-ar.jpg",
    description:
      "Empower field engineers with real-time augmented reality guidance, remote assistance and predictive maintenance capabilities.",
    tags: [
      "Remote Assistance",
      "Digital Twin",
      "AR Maintenance",
      "Smart Factory"
    ],
    link: "/industrialar"
  },

  {
    title: "Smart Surveillance",
    image: "assets/img/surveillance-banner.jpg",
    description:
      "AI-powered video analytics that transform surveillance into intelligent security with real-time threat detection and automation.",
    tags: [
      "AI Vision",
      "Object Detection",
      "Behavior Analytics",
      "Smart Security"
    ],
    link: "/smartsurveillance"
  },

  {
    title: "Case Studies",
    image: "assets/img/case-study.jpg",
    description:
      "Discover how Celersoft delivers measurable business outcomes through successful enterprise transformation projects across industries.",
    tags: [
      "Success Stories",
      "Customer Results",
      "ROI",
      "Innovation"
    ],
    link: "/case-studies"
  }
];

const [activeSolution, setActiveSolution] = useState(0);

    
    return (
        <>

            <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-indicators">
                    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
                    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3"></button>
                    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="3" aria-label="Slide 4"></button>
                    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="4" aria-label="Slide 5"></button>
                    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="5" aria-label="Slide 6"></button>
                </div>

                <div className="carousel-inner">
                    <div className="carousel-item active">
                        <img src="assets/img/infracaro.jpeg" className="d-block w-100" alt="Infrastructure Solutions" />
                        <div className="carousel-caption">
                            <h3>Infrastructure Solutions</h3>
                            <p>Cloud Infrastructure solutions, <br />Physical Infrastructure</p>
                        </div>
                    </div>

                    <div className="carousel-item">
                        <img src="assets/img/slide2.jpg" className="d-block w-100" alt="Business Analytics" />
                        <div className="carousel-caption">
                            <h3>Business Analytics</h3>
                            <p>The various data and analytical methods help businesses in taking <br /> effective C-Suite decisions</p>
                        </div>
                    </div>

                    <div className="carousel-item">
                        <img src="assets/img/slide4.jpg" className="d-block w-100" alt="Cyber Security" />
                        <div className="carousel-caption">
                            <h3>Cyber Security</h3>
                            <p>Continuously assess and mitigate risk from cyber attacks, devices, users, and applications</p>
                        </div>
                    </div>

                    <div className="carousel-item">
                        <img src="assets/img/sap1.png" className="d-block w-100" alt="SAP & ERP Solutions" />
                        <div className="carousel-caption">
                            <h3>SAP & ERP Solutions</h3>
                            <p>Optimizing Business Processes with Scalable SAP & ERP Solutions <br /> Empowering Efficiency, Innovation, and Growth</p>
                        </div>
                    </div>

                    <div className="carousel-item">
                        <img src="assets/img/microcaro2.jpeg" className="d-block w-100" alt="Micro Services" />
                        <div className="carousel-caption">
                            <h3>Micro Services</h3>
                            <p>Agile, Scalable, and Resilient <br /> Empowering Digital Transformation with Microservices Architecture</p>
                        </div>
                    </div>

                    <div className="carousel-item">
                        <img src="assets/img/itstaffing3.png" className="d-block w-100" alt="IT Staffing" />
                        <div className="carousel-caption">
                            <h3>IT Staffing</h3>
                            <p>Connecting Top IT Talent with Business Success <br /> Scalable, Flexible, and Future-Ready Staffing Solutions</p>
                        </div>
                    </div>
                </div>

                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>



            <div className="container-fluid about bg-light py-3">
                <div className="container py-3">
                    <div className="row g-5 align-items-center">
                        {/*
            <div className="col-lg-6 col-xl-5 wow fadeInLeft" data-wow-delay="0.1s">
                <div className="about-img">
                    <img src="assets/img/about.png" className="img-fluid w-100 rounded-top bg-white" alt="Image" />
                </div>
            </div> */}
                        <div>
                            <div className="col-lg-12 col-xl-12 wow fadeInRight" data-wow-delay="0.3s">
                                <h2 className="text-primary">At Celersoft LLC,</h2> {/*
                <h1 className="display-5 mb-4">c DELIVER IT SERVICES</h1> */}
                                <p className="text ps-4 mb-4">
                                    We empower businesses to navigate the future with confidence through innovative IT
                                    services and solutions. Our mission is to deliver tailored, cutting-edge strategies
                                    that drive growth, enhance efficiency, and enable success in an ever-evolving world.
                                    Partner with CelerSoft to unlock the potential of technology and achieve your goals
                                    with agility and excellence. Together, we’ll shape a smarter, more connected future.  </p>
                                <p className="text ps-4 mb-4">Our offerings span business and technology consulting, Infrastructure solutions,
                                    Business Analytics,
                                    ERP Solutions, Cybersecurity, Microservices, and IT Staffing.</p>

                            </div>
                            {/* <div className="row g-4 justify-content-between mb-2">
                    <div className="col-lg-6 col-xl-6">
                        <p className="text-dark">
                            <i className="fas fa-check-circle text-primary me-1" /> Strategy &amp; Consulting
                        </p>
                        <p className="text-dark mb-0">
                            <i className="fas fa-check-circle text-primary me-1" /> Business Process
                        </p>
                    </div>
                    <div className="col-lg-6 col-xl-6">
                        <p className="text-dark">
                            <i className="fas fa-check-circle text-primary me-1" />{" "} Marketing Rules
                        </p>
                        <p className="text-dark mb-0">
                            <i className="fas fa-check-circle text-primary me-1" />{" "} Partnerships
                        </p>
                    </div>
                </div> */}
                            {/*
                <div className="row g-4 justify-content-between mb-5">
                    <div className="col-xl-5">
                        <a href="/" className="btn btn-primary rounded-pill py-3 px-5">
                      Discover More
                    </a>
                    </div>
                    <div className="col-xl-7 mb-5">
                        <div className="about-customer d-flex position-relative">
                            <img src="assets/img/customer-img-1.jpg" className="img-fluid btn-xl-square position-absolute" style={{ left: 0, top: 0 }} alt="Image" />
                            <img src="assets/img/customer-img-2.jpg" className="img-fluid btn-xl-square position-absolute" style={{ left: 45, top: 0 }} alt="Image" />
                            <img src="assets/img/customer-img-3.jpg" className="img-fluid btn-xl-square position-absolute" style={{ left: 90, top: 0 }} alt="Image" />
                            <img src="assets/img/customer-img-1.jpg" className="img-fluid btn-xl-square position-absolute" style={{ left: 135, top: 0 }} alt="Image" />
                            <div className="position-absolute text-dark" style={{ left: 220, top: 10 }}>
                                <p className="mb-0">5m+ Trusted</p>
                                <p className="mb-0">Global Customers</p>
                            </div>
                        </div>
                    </div>
                </div> */}

                        </div>
                        {/*
            <div className="col-lg-6 col-xl-5 wow fadeInLeft" data-wow-delay="0.1s">
                <div className="row g-4 text-center align-items-center justify-content-center">
                    <div className="col-sm-4">
                        <div className="bg-primary rounded p-4">
                            <div className="d-flex align-items-center justify-content-center">
                                <span className="counter-value fs-1 fw-bold text-dark" data-toggle="counter-up">
                          200
                        </span>
                                <h4 className="text-dark fs-1 mb-0" style={{ fontWeight: 600, fontSize: 25 }}>
                          +
                        </h4>
                            </div>
                            <div className="w-100 d-flex align-items-center justify-content-center">
                                <p className="text-white mb-0">Projects Completed</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="bg-dark rounded p-4">
                            <div className="d-flex align-items-center justify-content-center">
                                <span className="counter-value fs-1 fw-bold text-white" data-toggle="counter-up">
                          21
                        </span>
                                <h4 className="text-white fs-1 mb-0" style={{ fontWeight: 600, fontSize: 25 }}>
                          +
                        </h4>
                            </div>
                            <div className="w-100 d-flex align-items-center justify-content-center">
                                <p className="mb-0">Clients</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="bg-primary rounded p-4">
                            <div className="d-flex align-items-center justify-content-center">
                                <span className="counter-value fs-1 fw-bold text-dark" data-toggle="counter-up">
                          57
                        </span>
                                <h4 className="text-dark fs-1 mb-0" style={{ fontWeight: 600, fontSize: 25 }}>
                          +
                        </h4>
                            </div>
                            <div className="w-100 d-flex align-items-center justify-content-center">
                                <p className="text-white mb-0">Team Members</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

                    </div>
                </div>
            </div>
{/* 
            <div className="container-fluid service py-3">
                <div className="container py-2">
                    <div className="text-center mx-auto pb-3 wow fadeInUp" data-wow-delay="0.1s" style={{ maxWidth: 800 }}>
                        <h2 className="text-primary">SERVICES WE PROVIDE</h2>
                    </div>
                    <div className="row pb-4 g-3 justify-content-center text-center"> */}
                        {/* <div className="col-md-6 col-lg-4 col-xl-4 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="service-item bg-light rounded">
                                <div className="service-img">
                                    <img src="assets/img/infrastructure1.jpg" className="img-fluid w-100 rounded-top" alt="" />
                                </div>
                                <div className="service-content text-center p-4">
                                    <div className="service-content-inner">
                                        <a href="/infrastructure" className="h4 mb-2 d-inline-flex text-start">
                                            <i className="fas fa-donate fa-2x me-2" /> Infrastructure Solutions
                                        </a>
                                        <p className="mb-4">
                                            Empower your business with robust, scalable, and secure infrastructure solutions designed to support today’s digital...
                                        </p>
                                        <a className="btn btn-light rounded-pill py-2 px-4" href="/infrastructure">
                                            Read More
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="col-md-6 col-lg-4 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="service-item bg-light rounded">
                                <div className="service-img">
                                    <img src="assets/img/businessanalytics.jpg" className="img-fluid w-100 rounded-top" alt="" />
                                </div>
                                <div className="service-content text-center p-4">
                                    <div className="service-content-inner">
                                        <a href="/business" className="h4 mb-2 d-inline-flex text-start">
                                            <i className="fas fa-donate fa-2x me-2" /> Business Analytics
                                        </a>
                                        <p className="mb-4">
                                            Unlock powerful insights and drive smarter decision-making with our Business Analytics solutions. We specialize ...
                                        </p>
                                        <a className="btn btn-light rounded-pill py-2 px-4" href="/business">
                                            Read More
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="col-md-6 col-lg-4 col-xl-4 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="service-item bg-light rounded">
                                <div className="service-img">
                                    <img src="assets/img/saperp.jpeg" className="img-fluid w-100 rounded-top" alt="" />
                                </div>
                                <div className="service-content text-center p-4">
                                    <div className="service-content-inner">
                                        <a href="/erp" className="h4 mb-2 d-inline-flex text-start">
                                            <i className="fas fa-donate fa-2x me-2" />ERP Solutions
                                        </a>
                                        <p className="mb-4">
                                            Streamline, innovate, and scale your business operations with our expert SAP services. Our team specializes in both SAP and Oracle...
                                        </p>
                                        <a className="btn btn-light rounded-pill py-2 px-4" href="/erp">
                                            Read More
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div> */}


                        {/*
            <div className="col-12">
                <a className="btn btn-primary rounded-pill py-3 px-5 wow fadeInUp" data-wow-delay="0.1s" href="/">
                  Services More
                </a>
            </div> */}
                    {/* </div> */}
                    {/* <div className="row g-3 justify-content-center text-center">
                        <div className="col-md-6 col-lg-4 col-xl-4 wow fadeInUp" data-wow-delay="0.7s">
                            <div className="service-item bg-light rounded">
                                <div className="service-img">
                                    <img src="assets/img/cybersecurity.jpg" className="img-fluid w-100 rounded-top" alt="" />
                                </div>
                                <div className="service-content text-center p-4">
                                    <div className="service-content-inner">
                                        <a href="/cyber" className="h4 mb-2 d-inline-flex text-start">
                                            <i className="fas fa-donate fa-2x me-2" /> Cybersecurity
                                        </a>
                                        <p className="mb-4">
                                            In today’s digital landscape, robust cybersecurity is essential for safeguarding sensitive data and ensuring business...
                                        </p>
                                        <a className="btn btn-light rounded-pill py-2 px-4" href="/cyber">
                                            Read More
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 col-xl-4 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="service-item bg-light rounded">
                                <div className="service-img">
                                    <img src="assets/img/microserv.jpeg" className="img-fluid w-100 rounded-top" alt="" />
                                </div>
                                <div className="service-content text-center p-4">
                                    <div className="service-content-inner">
                                        <a href="/micro" className="h4 mb-2 d-inline-flex text-start">
                                            <i className="fas fa-donate fa-2x me-2" /> Microservices
                                        </a>
                                        <p className="mb-4">
                                            Microservices architecture is transforming how applications are built, scaled, and managed. By breaking down...
                                        </p>
                                        <a className="btn btn-light rounded-pill py-2 px-4" href="/micro">
                                            Read More
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="service-item bg-light rounded">
                                <div className="service-img">
                                    <img src="assets/img/itstaff.jpg" className="img-fluid w-100 rounded-top" alt="" />
                                </div>
                                <div className="service-content text-center p-4">
                                    <div className="service-content-inner">
                                        <a href="/It" className="h4 mb-2 d-inline-flex text-start">
                                            <i className="fas fa-donate fa-2x me-2" /> IT Staffing
                                        </a>
                                        <p className="mb-4">

                                            Our IT recruitment services connect you with top talent, handpicked to drive your business forward. In today’s...
                                        </p>
                                        <a className="btn btn-light rounded-pill py-2 px-4" href="/It">
                                            Read More
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                {/* </div> */}
            {/* </div> */}
            
            {/* <div className="container-fluid project">
    <div className="container-fluid">
        <div className="text-center mx-auto pb-3 wow fadeInUp" data-wow-delay="0.1s" style={{ maxWidth: 800 }}>
            <h1 className="dispay-4">Case Studies</h1>
        </div>
        <div className="project-carouel owl-arousel ow fdeInUp" data-wow-delay="0.1s">

            <Carousel swipeable={true} draggable={true} showDots={true} responsive={responsive} ssr={true} infinite={true} autoPlay={true} autoPlaySpeed={8000} keyBoardControl={true} customTransition="all .5" transitionDuration={8000} containerClass="carousel-container"
            removeArrowOnDeviceType={[ "tablet", "mobile"]} deviceType={[ "desktop", "tablet", "mobile"]} dotListClass="custom-dot-list-style" itemClass="carousel-item-padding-40-px">
                <div className="projep">
                    <div className="project-img">
                        <img src="assets/img/dataflow-case-study.jpg" className="img-flid w-100 rouned" alt="Image" />
                    </div>
                    <div className="project-connt bg-ligt roundd p-4">
                        <div className="project-content-inner">
                            <div className="project-icon mb-3">
                                <i className="fas fa-chart-line fa-4x text-primary" />
                            </div>
                            <p className="text-drk fs-5 b-3">Data flow management</p>
                            <a href="/" className="h4">
                      Optimize resource utilization by moving data between data
                      centers or between on-premises infrastructure and cloud
                      infrastructure...
                    </a>
                            <div className="pt-4">
                                <a className="btn btn-light rounded-pill py-3 px-5" href="/">
                        Read More
                      </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="project-item h-100 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="project-img">
                        <img src="assets/img/cloud-case-study.jpg" className="img-fluid w-100 rounded" alt="Image" />
                    </div>
                    <div className="project-content bg-light rounded p-4">
                        <div className="project-content-inner">
                            <div className="project-icon mb-3">
                                <i className="fas fa-chart-line fa-4x text-primary" />
                            </div>
                            <p className="text-dark fs-5 mb-3">Cloud Migration</p>
                            <a href="/" className="h4">
                    Because the continuous replication occurs in the background, with no performance disruption, the actual cutover usually takes...
                    </a>
                            <div className="pt-4">
                                <a className="btn btn-light rounded-pill py-3 px-5" href="/">
                        Read More
                      </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="project-item h-100 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="project-img">
                        <img src="assets/img/sap-case-study.jpg" className="img-fluid w-100 rounded" alt="Image" />
                    </div>
                    <div className="project-content bg-light rounded p-4">
                        <div className="project-content-inner">
                            <div className="project-icon mb-3">
                                <i className="fas fa-chart-line fa-4x text-primary" />
                            </div>
                            <p className="text-dark fs-5 mb-3">ERP Solutions</p>
                          <a href="/" className="h4">
                          Streamline, innovate, and scale your business operations with our expert SAP services. Our team specializes in leveraging SAP’s powerful...
                          </a>
                            <div className="pt-4">
                                <a className="btn btn-light rounded-pill py-3 px-5" href="/erp-case-studies">
                        Read More
                      </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="project-item h-100 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="project-img">
                        <img src="assets/img/projects-1.jpg" className="img-fluid w-100 rounded" alt="Image" />
                    </div>
                    <div className="project-content bg-light rounded p-4">
                        <div className="project-content-inner">
                            <div className="project-icon mb-3">
                                <i className="fas fa-chart-line fa-4x text-primary" />
                            </div>
                            <p className="text-dark fs-5 mb-3">Data flow management 4</p>
                            <a href="/" className="h4">
                      Optimize resource utilization by moving data between data
                      centers or between on-premises infrastructure and cloud
                      infrastructure...
                    </a>
                            <div className="pt-4">
                                <a className="btn btn-light rounded-pill py-3 px-5" href="/">
                        Read More
                      </a>
                            </div>
                        </div>
                    </div>
                </div>
            </Carousel>
        </div>
    </div>
</div> */}

<section className="service-showcase py-5">

    <div className="container">

        <div className="text-center mb-5 wow fadeInUp">

            <h2 className="text-primary fw-bold">
                SERVICES WE PROVIDE
            </h2>

            <p className="text-muted mt-3">
                Accelerating Digital Transformation Across Every Layer
            </p>

        </div>

        <div className="row align-items-center">

            {/* LEFT MENU */}

            <div className="col-lg-4 mb-4 mb-lg-0">

                <div className="service-menu">

                    {services.map((item, index) => (

                        <div

                            key={index}

                            className={`service-nav-item ${activeService === index ? "active" : ""
                                }`}

                            onClick={() => setActiveService(index)}

                        >

                            <div className="service-number">

                                {item.number}

                            </div>

                            <div>

                                <h5>{item.title}</h5>

                                <span>{item.subtitle}</span>

                            </div>

                        </div>

                    ))}

                </div>

            </div>

            {/* RIGHT PANEL */}

            <div className="col-lg-8">

                <div className="service-display wow fadeIn">

                    <div className="row align-items-center">

                        <div className="col-lg-7">

                            <img

                                src={services[activeService].image}

                                className="img-fluid service-main-image"

                                alt=""

                            />

                        </div>

                        <div className="col-lg-5">

                            {/* <div className="service-details">

                                <span className="service-label">

                                    {services[activeService].number}

                                </span>

                                <h3>

                                    {services[activeService].title}

                                </h3>

                                <p>

                                    {services[activeService].description}

                                </p>

                                <div className="service-tags">

                                    {services[activeService].points.map((item, i) => (

                                        <span key={i}>

                                            {item}

                                        </span>

                                    ))}

                                </div>

                                <a

                                    href={services[activeService].link}

                                    className="btn btn-primary rounded-pill mt-4 px-4"

                                >

                                    Explore Service →

                                </a>

                            </div> */}

                            <div className="service-details">

    <span className="service-label">
        {services[activeService].number}
    </span>

    <h3>
        {services[activeService].title}
    </h3>

    <p>
        {services[activeService].description}
    </p>

    <div className="service-tags">

        {services[activeService].points.map((item, i) => (

            <span key={i}>
                {item}
            </span>

        ))}

    </div>

    
    <a
        href={services[activeService].link}
        className="btn btn-primary rounded-pill mt-4 px-4"
    >
        Explore Service →
    </a>

</div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

</section>

<section className="soc-assessment-section py-5">

    <div className="container">

        <div className="soc-card">

            <div className="row align-items-center">

    {/* IMAGE - FIRST ON MOBILE */}
    <div className="col-lg-4 order-1 order-lg-2 text-center">

        <div className="soc-icon-wrapper">
            <i className="fas fa-shield-alt"></i>
        </div>

    </div>


    {/* CONTENT - SECOND ON MOBILE */}
    <div className="col-lg-8 order-2 order-lg-1">

        <span className="soc-badge">
         SECURITY ASSESSMENT
        </span>

        <h2>
            SOC 2 & ISO 27001 Readiness Assessment
        </h2>

        <p>
            Evaluate your organization’s security controls, compliance maturity, and audit readiness
             through CelerSoft’s online assessment. Receive a detailed 
            gap analysis and actionable recommendations to accelerate SOC 2 and ISO 27001 compliance.
        </p>

        {/* <div className="soc-features">

            <div>
                <i className="fas fa-check-circle"></i>
                5-Minute Assessment
            </div>

            <div>
                <i className="fas fa-check-circle"></i>
                Instant Submission
            </div>

            <div>
                <i className="fas fa-check-circle"></i>
                Expert Review
            </div>

            <div>
                <i className="fas fa-check-circle"></i>
                Free Consultation
            </div>

        </div> */}

        <a
            href="https://forms.cloud.microsoft/pages/responsepage.aspx?id=MUA-T_DqkEqb1rQhz5s6rXUclN3LD91Op1IOACnr1QNUQUUzV0UxUFpJQjZaT05HMTlER0Y0MFZKTy4u&route=shorturl"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary btn-lg rounded-pill mt-4"
        >
            Start Assessment
            <i className="fas fa-arrow-right ms-2"></i>
        </a>

    </div>

</div>

        </div>

    </div>

</section>


<section className="solution-showcase py-5">

    <div className="container-fluid px-0">

        <div className="container">

            <div className="text-center mb-5 wow fadeInUp">

                <h2 className="text-primary fw-bold">

                    FEATURED SOLUTIONS

                </h2>

                <p className="text-muted">

                    Innovative technology solutions engineered for modern enterprises.

                </p>

            </div>

        </div>

        {/* Navigation */}

        <div className="solution-tabs">

            {solutions.map((item, index) => (

                <button

                    key={index}

                    onClick={() => setActiveSolution(index)}

                    className={`solution-tab ${
                        activeSolution === index ? "active" : ""
                    }`}

                >

                    {item.title}

                </button>

            ))}

        </div>

        {/* Banner */}

        <div

            className="solution-banner wow fadeIn"

            style={{
                backgroundImage: `url(${solutions[activeSolution].image})`
            }}

        >

            <div className="solution-overlay">

                <div className="container">

                    <div className="row align-items-center">

                        <div className="col-lg-7">

                            <span className="solution-subtitle">

                                FEATURED SOLUTION

                            </span>

                            <h2>

                                {solutions[activeSolution].title}

                            </h2>

                            <p>

                                {solutions[activeSolution].description}

                            </p>

                            <div className="solution-tags">

                                {solutions[activeSolution].tags.map((tag, i) => (

                                    <span key={i}>

                                        {tag}

                                    </span>

                                ))}

                            </div>

                            <a

                                href={solutions[activeSolution].link}

                                className="btn btn-light rounded-pill px-5 mt-4"

                            >

                                Explore Solution →

                            </a>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

</section>


            <div className="container-fluid testimonial bg-white py-3">
                <div className="container py-3">
                    <div className="row g-4 align-items-center">
                        <div className="col-xl-12 wow fadeInLeft" data-wow-delay="0.1s">
                            {/* <div className="h-100 rounded">
                                <h2 className="text-primary">OUR TRUSTED PARTNERS </h2>
                                <h1 className="display-4 mb-4">Clients are Talking</h1>
                                <p className="mb-4">
                                    Leading organizations trust Celersoft to deliver reliable technology solutions that strengthen security, modernize infrastructure, and accelerate digital transformation. Our commitment to quality, innovation,
                                    and customer success has helped us build lasting partnerships across multiple industries.                     </p>
                                <a className="btn btn-primary rounded-pill text-white py-3 px-5" href="/">
                                    Read All Reviews <i className="fas fa-arrow-right ms-2" />
                                </a>
                            </div> */}
                        </div>
                        {/* <div className="col-xl-12">

                            <Carousel2 responsive={responsive}>

                                <div className="testimonial-item bg-white rounded p-4 wow fadeInUp" data-wow-delay="0.3s">
                                    <div className="d-flex">
                                        <div>
                                            <i className="fas fa-quote-left fa-3x text-dark me-3" />
                                        </div>
                                        <p className="mt-4">
                                            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Magnam eos impedit eveniet dolorem culpa ullam incidunt vero quo recusandae nemo? Molestiae doloribus iure,
                                        </p>
                                    </div>
                                    <div className="d-flex justify-content-end">
                                        <div className="my-auto text-end">
                                            <h5>Person Name</h5>
                                            <p className="mb-0">Profession</p>
                                        </div>
                                        <div className="bg-white rounded-circle ms-3">
                                            <img src="assets/img/testimonial-1.jpg" className="rounded-circle p-2" style={{ width: 80, height: 80, border: "1px solid", borderColor: "var(--bs-primary)" }} alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className="testimonial-item bg-white rounded p-4 wow fadeInUp" data-wow-delay="0.5s">
                                    <div className="d-flex">
                                        <div>
                                            <i className="fas fa-quote-left fa-3x text-dark me-3" />
                                        </div>
                                        <p className="mt-4">
                                            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Magnam eos impedit eveniet dolorem culpa ullam incidunt vero quo recusandae nemo? Molestiae doloribus iure,
                                        </p>
                                    </div>
                                    <div className="d-flex justify-content-end">
                                        <div className="my-auto text-end">
                                            <h5>Person Name</h5>
                                            <p className="mb-0">Profession</p>
                                        </div>
                                        <div className="bg-white rounded-circle ms-3">
                                            <img src="assets/img/testimonial-2.jpg" className="rounded-circle p-2" style={{ width: 80, height: 80, border: "1px solid", borderColor: "var(--bs-primary)" }} alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className="testimonial-item bg-white rounded p-4 wow fadeInUp" data-wow-delay="0.7s">
                                    <div className="d-flex">
                                        <div>
                                            <i className="fas fa-quote-left fa-3x text-dark me-3" />
                                        </div>
                                        <p className="mt-4">
                                            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Magnam eos impedit eveniet dolorem culpa ullam incidunt vero quo recusandae nemo? Molestiae doloribus iure,
                                        </p>
                                    </div>
                                    <div className="d-flex justify-content-end">
                                        <div className="my-auto text-end">
                                            <h5>Person Name</h5>
                                            <p className="mb-0">Profession</p>
                                        </div>
                                        <div className="bg-white rounded-circle ms-3">
                                            <img src="assets/img/testimonial-3.jpg" className="rounded-circle p-2" style={{ width: 80, height: 80, border: "1px solid", borderColor: "var(--bs-primary)" }} alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className="testimonial-item bg-white rounded p-4 wow fadeInUp" data-wow-delay="0.3s">
                                    <div className="d-flex">
                                        <div>
                                            <i className="fas fa-quote-left fa-3x text-dark me-3" />
                                        </div>
                                        <p className="mt-4">
                                            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Magnam eos impedit eveniet dolorem culpa ullam incidunt vero quo recusandae nemo? Molestiae doloribus iure,
                                        </p>
                                    </div>
                                    <div className="d-flex justify-content-end">
                                        <div className="my-auto text-end">
                                            <h5>Person Name</h5>
                                            <p className="mb-0">Profession</p>
                                        </div>
                                        <div className="bg-white rounded-circle ms-3">
                                            <img src="assets/img/testimonial-1.jpg" className="rounded-circle p-2" style={{ width: 80, height: 80, border: "1px solid", borderColor: "var(--bs-primary)" }} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </Carousel2>

                        </div> */}




                        <div className="row align-items-center py-5 partner-wrapper">
                            <h2 className="text-primary text-center">OUR TRUSTED PARTNERS </h2>
                            <h5 style={{ textAlign: "center" }}>Trusted by Businesses Across Industries </h5>
                            <p>Leading organizations trust Celersoft to deliver reliable technology solutions that strengthen security, modernize infrastructure, and accelerate digital transformation. Our commitment to quality, innovation,
                                and customer success has helped us build lasting partnerships across multiple industries. </p>

                            {/* Indigo */}

                            <div
                                className="col-lg-5 text-center wow fadeInLeft"
                                data-wow-delay="0.2s"
                            >

                                <img
                                    src="assets/img/indigo.png"
                                    className="partner-logo"
                                    alt=""
                                />

                                <h4 className="mt-4">Indigo Affect</h4>

                                <span className="partner-badge">
                                    Technology Partner
                                </span>

                                <p className="mt-3">

                                    Indigo Affect enables organizations to accelerate digital
                                    transformation through innovative enterprise technology,
                                    consulting and intelligent business solutions.

                                </p>

                            </div>


                            {/* Center */}

                      

                            <div 
                                className="col-lg-2 text-center wow zoomIn"
                                data-wow-delay="0.8s"
                            >
                                <img style={{ width: 593 }}
                                    src="assets/img/Trusted-Partner.png"
                                    className="partner-badge-img"
                                    alt="Trusted Partner" 
                                />

                                <h5 className="mt-3 partner-title">
                                    CELERSOFT
                                </h5>
                            </div>


                            {/* Kloudspot */}

                            <div
                                className="col-lg-5 text-center wow fadeInRight"
                                data-wow-delay="0.4s"
                            >

                                <img
                                    src="assets/img/kloudspot1.png"
                                    className="partner-logo"
                                    alt=""
                                />

                                <h4 className="mt-4">Kloudspot</h4>

                                <span className="partner-badge">
                                    Strategic Partner
                                </span>

                                <p className="mt-3">

                                    Kloudspot delivers AI-powered location intelligence,
                                    IoT analytics and smart workplace solutions that help
                                    enterprises improve operational efficiency.

                                </p>

                            </div>

                        </div>


                        <div className="col-xl-12">
                            <div className="section-title text-center wow zoomIn clients" style={{ visibility: "visible", animationName: "zoomIn" }}>
                                <h2 className="text-primary text-center">BRANDS WE SUPPORT </h2>
                                <h5>Building Long-Term Partnerships Through Innovation</h5>
                                <p>Every successful project starts with trust. We are proud to work with organizations ranging from growing businesses to global enterprises, delivering secure, scalable, and innovative IT solutions that help them achieve their business goals. </p>
                            </div>
                            <Carousel3 responsive={responsive2} infinite={true} autoPlay={true} partialVisbile={false} autoPlaySpeed={2000} containerClass="client-carousel" itemClass="client-carousel-item" renderButtonGroupOutside={true} showDots={false}>




                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/cdw.jpg" alt="CDW" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/biz.jpg" alt="Biz Tech" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/at.jpg" alt="AT&T" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/yoh.jpg" alt="YOH" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/vdart.jpg" alt="VDART" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/toyata.jpg" alt="TOYATA" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/recruit121.jpg" alt="RECRUIT121" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/newbold.jpg" alt="NEWBOLD" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/techmahindra.jpg" alt="TECH MAHINDRA" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/shell.jpg" alt="SHELL" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/neighbourly.jpg" alt="NEIGHBOURLY" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/killeen.jpg" alt="KILLEEN" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/infodat.jpg" alt="INFODAT" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/gac.jpg" alt="GAC" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/fairway.jpg" alt="FAIRWAY LAWNS" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/ups.jpg" alt="UPS" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/compnova.jpg" alt="COMPNOVA" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/cognizant.jpg" alt="COGNIZANT" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/bjc.png" alt="BJC" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/bluecross.png" alt="Blue Cross" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/livebetter.png" alt="livebetter" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/al-khalili.png" alt="al-khalili" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/alwatania-poultry.png" alt="alwatania" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/atolye.png" alt="atolye" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/auro-realty.png" alt="auro realty" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/bahwan-it.png" alt="bahwan it" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/nigerian-national-petroleum.png" alt="nigerian national petroleum" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/nigerial-lng.png" alt="nigerial lng" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/royaloperahouse-muscat.png" alt="royaloperahouse muscat" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/spimaco-adwaeih.png" alt="spimaco adwaeih" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/omantel.png" alt="omantel" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/mbholding.png" alt="mbholding" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/mccormick.png" alt="mccormick" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/nga.png" alt="nga" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/tollplus.png" alt="tollplus" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/coromandel.png" alt="coromandel" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/club-mahindra.png" alt="club mahindra" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/nsl-group.png" alt="nsl group" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/southern-power-distribution.png" alt="southern power distribution" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/shreeja.png" alt="shreeja" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/wisys.png" alt="wisys" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/ramky.png" alt="ramky" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/highco.png" alt="highco" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/hf.png" alt="hf" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/grg-cotspin.png" alt="grg cotspin" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/tronox.png" alt="tronox" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/ntt-data.png" alt="ntt data" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/hexagon.png" alt="hexagon" />{" "}
                                    </div>
                                </div>

                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/aurzy.png" alt="Aurzy" />{" "}
                                    </div>


                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/kloudspot.png" alt="kloudspot" />{" "}
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: 293 }}>
                                    <div className="item">
                                        {" "}
                                        <img src="/assets/img/usmca.png" alt="USMCA" />{" "}
                                    </div>
                                </div>
                            </Carousel3>
                        </div>

                    </div>
                </div>
            </div>

            {/* Footer */}
            <div className="container-fluid footer wow fadeIn" data-wow-delay="0.2s">
                <div className="container pt-4">
                    <div className="row g-5">
                        <div className="col-md-6 col-lg-6 col-xl-3">
                            <p><span style={{ fontSize: 20 }}><em><strong>USA</strong></em></span></p>
                            <p><i className="fas fa-map-marker me-1" /> 1500 S Dairy Ashford Rd <br /> Ste 355 Houston, TX 77077</p>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-3">
                            <p><em><span style={{ fontSize: 20 }}><strong>CANADA</strong></span></em></p>
                            <p><i className="fas fa-map-marker me-1" /> 998 Loft Court, London, Ontario, N6G0J9</p>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-3">
                            <p><span style={{ fontSize: 20 }}><em><strong>INDIA</strong></em></span></p>
                            <p><i className="fas fa-map-marker me-1" /> D. No. 38, 2nd Floor, Arjun Plaza, SP Road, Nizampet, Hyderabad, Telangana - 500085</p>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-3">
                            <div className="footer-item d-flex flex-column">
                                <a href="mailto:info@celersoft.com"><i className="fas fa-envelope me-2" /> info@celersoft.com</a>
                                <a href="tel:+18322258898"><i className="fas fa-phone me-2" /> (+1) 832-225-8898</a>
                                <hr />
                                <div className="d-flex align-items-center">
                                    <a className="btn btn-light btn-md-square me-2" href="https://www.facebook.com/celersoft">
                                        <i className="fab fa-facebook-f" />
                                    </a>
                                    <a className="btn btn-light btn-md-square me-0" href="https://www.linkedin.com/company/celersoft/">
                                        <i className="fab fa-linkedin-in" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid copyright py-3">
                <div className="container">
                    <div className="row g-4 align-items-center">
                        <div className="col-md-6 text-center text-md-start mb-md-0">
                            <span className="text-body">
                                <i className="fas fa-copyright text-light me-1" />
                                2024 Celersoft. All rights reserved.
                            </span>
                        </div>
                        {/* <div className="col-md-6 text-center text-md-end text-body">
              <a
                    className="border-bottom text-primary"
                    href="https://htmlcodex.com"
                >
                    HTML Codex
                </a>{" "}
                Distributed By{" "}
                <a
                    className="border-bottom text-primary"
                    href="https://themewagon.com"
                >
                    ThemeWagon
                </a>


              </div> */}
                    </div>
                </div>
            </div>

            {/* <a href="/" className="btn btn-primary btn-lg-square back-to-top">
          <i className="fa fa-arrow-up" />
        </a> */}

            <button
                className="btn btn-primary btn-lg-square back-to-top"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
                <i className="fa fa-arrow-up" />
            </button>

        </>


    );
};

export default Home